export enum GamesFilterSortType {
    Default = "Default",
    Newest = "Newest",
    Oldest = "Oldest",
    MostPlayed = "MostPlayed",
}

export interface GamesFilterParameters {
    genres: string[];
    manufacturers: string[];
    reels: string[];
    lines: string[];
    sortType: GamesFilterSortType;
    pageSize: number;
    page: number;
    getCountOnly: boolean;
}
